import { DefaultTheme, ThemedStyledProps, ThemeProps } from "styled-components";
import { Props } from "components/Flex/FlexItem";

const myTheme: DefaultTheme = {
  colors: {
    background: {
      default: "#f3f5f9",
      light: "#f5f4f6",
      white: "#fff",
      dark: "#17283c"
    },
    black: "#000000",
    white: "#ffffff",
    muted: "#c2c2c2",
    border: "#d4d4d5",
    disabled: "#E2E5EE",
    success: "#21ba45",
    primary: {
      dark: "#007ac1",
      default: "#2bb9ad",
      light: "#67daff"
    },
    secondary: {
      dark: "#a00037",
      default: "#d81b60",
      light: "#ff5c8d"
    }
  }
};

export type MarginDescription = "small" | "medium" | "large";

export const getBackgroundColor = (
  props: ThemedStyledProps<Props, DefaultTheme>
) => {
  switch (props.colorTheme) {
    case "dark":
      return themeColors(props).background.dark;
    default:
      return "transparant";
  }
};

export function getMargin(margin: MarginDescription) {
  if (margin === "small") {
    return `0.8rem`;
  } else if (margin === "medium") {
    return `calc(0.8rem * 2)`;
  } else if (margin === "large") {
    return `calc(0.8rem * 4)`;
  }
}

export type ColorDescription =
  | "default"
  | "background"
  | "muted"
  | "primary"
  | "success"
  | "danger"
  | "strong"
  | "white"
  | undefined;

export function getColorByDescription(
  props: ThemeProps<DefaultTheme>,
  description: ColorDescription
) {
  switch (description) {
    case "muted":
      return themeColors(props).muted;
    case "success":
      return themeColors(props).success;
    case "danger":
      return themeColors(props).secondary.default;
    case "primary":
      return themeColors(props).primary.default;
    case "strong":
      return themeColors(props).black;
    case "white":
      return themeColors(props).white;
    case "background":
      return themeColors(props).background.default;
    default:
      return undefined;
  }
}

export function themeColors(props: ThemeProps<DefaultTheme>) {
  return (props.theme || myTheme).colors || myTheme.colors;
}

export default myTheme;
